/*
 * @Author: 史金波
 * @Date: 2021-12-14 09:04:18
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-15 15:49:56
 * @FilePath: \saas-perform-web\src\api\distributor\distributorApi.js
 */
import {httpPost,httpGet,baseUrl} from "../axiosFun.js"

export function saveDistributorApi(data) {
	return httpPost(baseUrl + "/distribution/insert",data)
}

export function searchAllApi(data) {
	return httpPost(baseUrl + "/distribution/selectAll",data)
}

export function searchDetailApi(data){
	return httpGet(baseUrl + "/distribution/detail",data)
}

export function businessStartOrStop(data){
	return httpGet(baseUrl + "/distribution/business/stopOrStart",data)
}

export function advanceConfigSearchApi(id){
	return httpGet(baseUrl + "/distribution/advance/search?id="+id)
}

export function settingAdvanceConfig(data){
	return httpPost(baseUrl + "/distribution/advance/insert",data)
}

export function periodListApi(data){
	return httpGet(baseUrl + "/period/list",data)
}

export function periodAddApi(data){
	return httpPost(baseUrl + "/period/add",data)
}

export function serviceConfigInsertApi(data){
	return httpPost(baseUrl + "/distribution/serviceConfig/insert",data)
}

export function serviceConfigSearchApi(data){
	return httpGet(baseUrl + "/distribution/serviceConfig/search",data)
}

export function cakeBrandsInfoApi(){
	return httpGet(baseUrl + "/distribution/cake/findAll")
}

export function brandSettingSearchApi(data){
	return httpPost(baseUrl + "/distribution/search/brandSetting",data)
}

export function saveBrandConfsApi(data){
	return httpPost(baseUrl + "/distribution/setting/brandConfs",data)
}


// WEBPACK FOOTER //
// ./src/api/distributor/distributorApi.js